import styled from 'styled-components/macro';

const RadiosWrapper = styled.div`
  display: flex;
`;

export default RadiosWrapper;
